/**
 * @generated SignedSource<<84a7fbc9d8d0359004656ca2ceec3e2c>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type Law = "IVG" | "KVG" | "MVG" | "ORG" | "UVG" | "VVG";
export type NotBillableReason = "ADMINISTRATIVE" | "INCOMPLETE_CONSULTATION" | "OTHER_REASON";
export type Service = "ADMINISTRATIVE_REQUEST" | "CONSULTATION" | "EMERGENCY_LINE" | "KIDS_LINE" | "MEDGATE_CONNECT" | "PREVENTION_ASSESSMENT" | "PSYCHOSOCIAL" | "STUDY_CALL" | "TELE_GENERAL_PRACTITIONER";
export type TreatmentReason = "ACCIDENT" | "CONGENITAL_DEFECT" | "MATERNITY" | "PREVENTION" | "SICKNESS";
import { FragmentRefs } from "relay-runtime";
export type chBillingDialogContentBillingFragment$data = {
  readonly billingAttribute: {
    readonly accidentReference: string | null;
    readonly currentGestationWeek: number | null;
    readonly dateOfAccident: any | null;
    readonly id: string;
    readonly isEmployer: boolean | null;
    readonly isNotBillable: boolean;
    readonly ivgCaseReference: string | null;
    readonly lawType: Law | null;
    readonly mvgCaseReference: string | null;
    readonly notBillableReason: NotBillableReason | null;
    readonly organisationId: string | null;
    readonly reason: string | null;
    readonly treatmentReason: TreatmentReason | null;
  } | null;
  readonly id: string;
  readonly service: Service;
  readonly " $fragmentType": "chBillingDialogContentBillingFragment";
};
export type chBillingDialogContentBillingFragment$key = {
  readonly " $data"?: chBillingDialogContentBillingFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"chBillingDialogContentBillingFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "chBillingDialogContentBillingFragment",
  "selections": [
    (v0/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "service",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "BillingAttribute",
      "kind": "LinkedField",
      "name": "billingAttribute",
      "plural": false,
      "selections": [
        (v0/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isNotBillable",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "notBillableReason",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "treatmentReason",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "reason",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "currentGestationWeek",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "organisationId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "dateOfAccident",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "accidentReference",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isEmployer",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lawType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "ivgCaseReference",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "mvgCaseReference",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Appointment",
  "abstractKey": null
};
})();

(node as any).hash = "037f9a45a6d8da94702c0786fa503b25";

export default node;
